import axiosHttpRequest from "../axios"



async function listDsrService(endpoint, queryparams, configheaders) {
    const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

    let serviceData = serviceResponse.data;
    let listViewData = [];
    let listViewInfo = {};
    if (serviceData.issuccess && serviceData.Records) {
        listViewData = serviceData.Records;
    }
    listViewInfo.records = listViewData;
    listViewInfo.paginationInfo = serviceData.paginationinfo;
    return listViewInfo;
}
async function downloadDsrReportService(endpoint, filename, configheaders) {
    axiosHttpRequest.execGetRequestsDownloadFile(endpoint, filename, configheaders)
}
async function activeJobdetailsService(endpoint, queryparams, configheaders) {
    const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(endpoint, queryparams, configheaders);

    let serviceData = serviceResponse.data;
    let listViewData = [];
    if (serviceData.issuccess && serviceData.Records) {
        listViewData = serviceData.Records;
    }
    // listViewInfo.records = listViewData;
    // listViewInfo.paginationInfo = serviceData.paginationinfo;
    return listViewData;
}

export default {
    listDsrService,
    downloadDsrReportService,
    activeJobdetailsService
};



